import { CostApi, Cost } from '../models';

export function mapCostApiToCost(costApi: CostApi): Cost {
  return {
    id: costApi.id,
    name: costApi.name,
    costMode: costApi.costMode,
    vehicleType: costApi.vehicleType,
    amount: costApi.amount,
    validFrom: costApi.validFrom,
    validTo: costApi.validTo,
  };
}
